// This file is auto-generated by dibs-icons script
import { FC } from 'react';
import CheckCircle20 from './CheckCircle20';
import CheckCircle20Filled from './CheckCircle20Filled';
import CheckCircle24 from './CheckCircle24';
import CheckCircle24Filled from './CheckCircle24Filled';

type CheckCircleProps = {
    size?: number;
    filled?: boolean;
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    CheckCircle20,
    CheckCircle20Filled,
    CheckCircle24,
    CheckCircle24Filled,
};

const CheckCircle: FC<CheckCircleProps> = ({ size = 20, filled = true, ...props }) => {
    const variationKey = `CheckCircle${size}${
        filled ? 'Filled' : ''
    }` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    return <Icon {...props} />;
};

export default CheckCircle;
